<template>
    <div class="product-page">
        <div class="matrix-header">
            <h2>智能水肥一体机（专业版）</h2>
            <p>省水省肥又省力 增产增收不是梦</p>
        </div>

        <div class="content-wrapper">
            <div class="container">
                <div class="product-card">
                    <el-row :gutter="150" class="product-content">
                        <el-col :span="9" class="product-left" style="padding-right: 0px;padding-left: 100px;">

                            <div class="main-image-container">
                                <img src="@/assets/images/HardwareDetails/juanlianji-qj/sfj.png" :alt="products.title"
                                    class="main-image">
                            </div>
                            <div class="detail-images">
                                <div class="detail-image-item1">
                                    <img src="@/assets/images/HardwareDetails/juanlianji-qj/zhdn.png" alt="控制界面"
                                        class="detail-image">
                                </div>

                                <div class="detail-image-item">
                                    <img src="@/assets/images/HardwareDetails/juanlianji-qj/tao.png" alt="控制板"
                                        class="detail-image">
                                </div>
                                <div class="detail-image-item">
                                    <img src="@/assets/images/HardwareDetails/juanlianji-qj/three.png" alt="机械细节"
                                        class="detail-image">
                                </div>
                            </div>
                        </el-col>

                        <el-col :span="15" class="product-right">
                            <div class="spec-section1">
                                <h3 class="section-title">主机参数</h3>
                                <el-row :gutter="10">
                                    <el-col :span="8" v-for="(spec, index) in products.mainSpecs" :key="index"
                                        class="spec-col">
                                        <div class="spec-item">
                                            <div class="spec-label">{{ spec.label }}</div>
                                            <div class="spec-value">{{ spec.value }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>

                            <div class="spec-section">
                                <h3 class="section-title">施肥</h3>
                                <el-row :gutter="10">
                                    <el-col :span="8" v-for="(spec, index) in products.electronicLimiter" :key="index"
                                        class="spec-col">
                                        <div class="spec-item">
                                            <div class="spec-label">{{ spec.label }}</div>
                                            <div class="spec-value">{{ spec.value }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>

                            <div class="spec-section">
                                <h3 class="section-title">灌溉</h3>
                                <el-row :gutter="10">
                                    <el-col :span="8" v-for="(spec, index) in products.mechanicalLimiter" :key="index"
                                        class="spec-col">
                                        <div class="spec-item">
                                            <div class="spec-label">{{ spec.label }}</div>
                                            <div class="spec-value">{{ spec.value }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="control-mechanism">
                                <h3 class="section-title">自动控制机制</h3>
                                <div class="control-items">
                                    <div class="control-item" v-for="(control, index) in products.autoControls"
                                        :key="index">
                                        <h4 class="control-type">
                                            <img src="@/assets/images/HardwareDetails/juanlianji-qj/shezhi.png"
                                                :alt="`${control.type}图标`" class="control-icon">
                                            {{ control.type }}
                                        </h4>
                                        <p class="control-description">{{ control.description }}</p>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>

                    <div class="data-control-section">
                        <el-row :gutter="24" class="combined-section">
                            <el-col :span="12" class="combined-item">
                                <div class="data-collection">
                                    <h3 class="section-title">数据采集</h3>
                                    <el-row :gutter="12">
                                        <el-col :span="8" v-for="(item, index) in products.dataCollection" :key="index">
                                            <div class="data-item">
                                                <div class="data-label">{{ item.label }}</div>
                                                <div class="data-value">{{ item.value }}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>

                                <div class="data-collection">
                                    <h3 class="section-title">智能控制</h3>
                                    <el-row :gutter="12">
                                        <el-col :span="8" v-for="(item, index) in products.contrl" :key="index">
                                            <div class="data-item">
                                                <div class="data-label">{{ item.label }}</div>
                                                <div class="data-value">{{ item.value }}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>

                            <el-col :span="12" class="combined-item">
                                <div class="data-collection">
                                    <h3 class="section-title">智能预警</h3>
                                    <el-row :gutter="12">
                                        <el-col :span="12" v-for="(item, index) in products.warnings" :key="index">
                                            <div class="data-item">
                                                <div class="data-label">{{ item.type }}</div>
                                                <div class="data-value">{{ item.description }}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="application-scenarios">
                        <h3 class="section-title">应用场景</h3>
                        <el-row :gutter="16">
                            <el-col :span="6" v-for="(scene, index) in products.scenarios" :key="index">
                                <div class="scene-card">
                                    <div class="scene-image-container">
                                        <img :src="scene.image" :alt="scene.title" class="scene-image">
                                        <div class="scene-title-overlay">
                                            <p class="scene-title">{{ scene.title }}</p>
                                        </div>
                                    </div>
                                    <div class="scene-description">
                                        <p>{{ scene.description }}</p>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="related-products">
                        <h3 class="section-title">相关产品推荐</h3>
                        <el-row :gutter="20">
                            <el-col :span="8" v-for="(product, index) in relatedProducts" :key="index">
                                <div class="related-product-card">
                                    <div class="related-product-image-container">
                                        <img :src="product.image" :alt="product.title" class="related-product-image">
                                    </div>
                                    <div class="related-product-info">
                                        <h4 class="related-product-title">{{ product.title }}</h4>
                                        <p class="related-product-description">{{ product.description }}</p>
                                        <div class="view-details" @click="goToTypicalcase(product.path)">
                                            <span>查看详情</span>
                                            <img src="@/assets/images/HardwareDetails/juanlianji-qj/xiangqing.png"
                                                alt="箭头" class="arrow-icon">
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            products: {
                title: '智能水肥一体机（专业版）',
                tags: ['自动模式', '手动模式', '智能预警', '远程控制'],
                scenarios: [
                    {
                        title: '大型温室大棚',
                        description: '为大型温室大棚提供智能化环境控制解决方案，集成物联网技术与智能控制系统，实现温室环境的智能调节与远程监控，提升温室作物的生长效率与品质。',
                        image: require('@/assets/images/HardwareDetails/juanlianji-qj/dp.png')


                    },
                    {
                        title: '智慧农业基地',
                        description: '为现代化农业基地提供一体化智能解决方案，集成物联网技术与智能控制系统，实现农作物生长环境的智能调节与远程监控，大幅提升农业生产效率。',
                        image: require('@/assets/images/HardwareDetails/juanlianji-qj/ny.png')

                    },
                    {
                        title: '花卉培育中心',
                        description: '专门针对花卉培育环境开发的智能控制方案，可根据不同花卉品种的生长需求，精确控制温度、湿度等环境参数，为高品质花卉培育提供最佳生长环境。',
                        image: require('@/assets/images/HardwareDetails/juanlianji-qj/hh.png')

                    },
                    {
                        title: '蔬果种植基地',
                        description: '针对大规模蔬果种植基地设计的智能化环境控制系统，具备分区管理功能，可根据不同作物的生长周期自动调节环境参数，确保产量与品质的最优化。',
                        image: require('@/assets/images/HardwareDetails/juanlianji-qj/sg.png')

                    }
                ],
                mainSpecs: [
                    { label: '尺寸', value: '300x400x250mm' },
                    { label: '材质', value: ' ABS抗老化白色' },
                    { label: '供电', value: '  220V AC ' },
                    { label: '功率', value: '10W' },
                    { label: '人机交互', value: '工业高清触摸屏|7寸' },
                    { label: '防护等级', value: 'IP64' },
                    { label: '安装方式', value: '预制基础' },
                    { label: '通信', value: '  4G通信 含3年流量' },
                ],
                electronicLimiter: [
                    { label: '施肥方式', value: '旁路式' },
                    { label: '施肥管道', value: ' 尺寸：de32；接口：2个（进肥口/出肥口）' },
                    { label: '施肥流量', value: '0-1000 L/h' },
                    { label: '施肥桶', value: ' 120L|黄色|搅拌电机' },
                    { label: '施肥保护', value: '低液位保护，防止施肥泵空转损坏' },
                    { label: '搅拌电机', value: '供电：220V AC ；电机功率：140w' },
                    { label: '注肥泵', value: '供电：220V AC ；额定流量：4 m³/h；最高扬程：44m；电机功率：0.37kw' }
                ],
                mechanicalLimiter: [
                    { label: '电磁阀', value: ' 220V AC （供电）；尺寸：（根据主管道定制）' },
                    { label: '远传水表', value: '供电：12V DC；信号： 1脉冲=0.01m³；尺寸：根据主管道定制' },
                ],
                modes: {
                    auto: '只有将设备切换至自动模式时，电子限位、设备控制、设备预警以及自动控制等全部功能方可正常启用，为您带来便捷、智能的操控体验，全方位保障设备运行的安全性与稳定性。',
                    manual: '当设备处于手动模式时，仅机械限位发挥保护作用。在该模式下，您可通过手动操作实现对设备的基本控制，但自动模式下的部分智能化功能将无法使用。'
                },
                dataCollection: [
                    { label: '累计流量', },
                    { label: '瞬时流量', },
                ],
                //智能控制
                contrl: [
                    { label: '灌溉', value: '打开/关闭' },
                    { label: '施肥', value: '打开/关闭' },
                    { label: '搅拌', value: '打开/关闭' },

                ],
                warnings: [
                    { type: '电力异常预警', description: '系统快速捕捉异常断电、电流过大等电力突变，及时提醒，避免因电力问题影响作物生长。' },
                    { type: '施肥过程预警', description: '当肥料余量不足时，系统会发出 “请补充肥料！”' },
                ],
                autoControls: [
                    {
                        type: '定时定量灌溉',
                        description: '可设置定时时间（精确到时分）、是否重复、定时周期及灌溉阈值'
                    },

                ]
            },
            relatedProducts: [
                {
                    title: '芯棚到家智能放风机（旗舰版）',
                    description: '温控数据全知晓  智能放风护苗好',
                    image: require('@/assets/images/MainHardware/ffj-qj.png'),
                    path: '/FangfengjiDetails'

                },
                {
                    title: '智能卷帘机自动止停器（旗舰版）',
                    description: '人在家中睡，一键起棉被！',
                    image: require('@/assets/images/MainHardware/jlj-qj.png'),
                    path: '/juanlianji-qi'

                },
                {
                    title: '多参数温室环境传感器系列',
                    description: '多参数精准感知  重塑环境监测新高度',
                    image: require('@/assets/images/MainHardware/wscgq.png'),
                    path: '/CanshuDetails'

                }
            ]
        };
    },
    methods: {
        goToTypicalcase(path) {
            if (!path) {
                console.error('Invalid route path');
                return;
            }
            this.$router.push(path).then(() => {
                // 滚动到顶部逻辑
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    }
};
</script>
